import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { viewAdminCoursesApi } from "../../../apis";
import PageTitle from "../../../Components/UI/PageTitle";
import CustomPagination from "../../../Components/CustomPagination";
import RowLoader from "../../../Components/UI/RowLoader";

const Reports = () => {
  const [courses, setCourses] = useState([]);
  const [paginator, setPaginator] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const location = useLocation();

  const [currentPage, setCurrentPage] = useState(
    parseInt(new URLSearchParams(location.search).get("page"), 10) || 1
  );

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const fetchCourses = async () => {
    setLoading(true);
    try {
      const response = await viewAdminCoursesApi(currentPage);
      setCourses(response.data.data);
      setPaginator(response.data.paginator);
    } catch (error) {
      setError("Failed to fetch courses");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCourses();
  }, [currentPage]);

  // if (loading) return <Loader />;

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <>
      <PageTitle title="Enrollments Report" />

      <div className="card tw-min-w-[340px]">
        <div className="card-header d-flex align-items-center justify-content-between">
          <h4 className="card-title mb-0 tw-text-[20px]">Courses List</h4>
        </div>
        {loading ? (
          <div className="tw-mx-auto">
            <RowLoader />
          </div>
        ) : (
          <div className="card-body">
            <div className="row !tw-overflow-auto">
              <div className="col-md-12 mb-3">
                <table className="table">
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Course</th>
                      <th>Is Active</th>
                      <th>Enrolled Partners</th>
                      <th>Partners List</th>
                    </tr>
                  </thead>

                  <tbody>
                    {courses.length > 0 ? (
                      courses.map((course, index) => (
                        <tr key={course.id}>
                          <td>{index + 1}</td>
                          <td className="tw-min-w-[200px]">
                            <img
                              src={course.image || "/imgs/notFound.jpg"}
                              alt={course.course_name_en}
                              className="tw-rounded-full tw-w-10 tw-h-10 tw-shrink-0 d-inline-block"
                            />
                            <span className="tw-ms-4">
                              {course.course_name_en}
                            </span>
                          </td>
                          <td className="tw-min-w-[100px]">
                            {course.is_active}
                          </td>
                          <td className="tw-min-w-[100px]">
                            {course.enrolled_partners}
                          </td>
                          <td className="tw-min-w-[100px]">
                            <Link
                              className="tw-text-primary tw-font-semibold"
                              to={`/reports/${course.id}`}
                            >
                              View
                            </Link>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5">No courses available</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="flex justify-center mt-4">
              <CustomPagination
                totalPages={paginator?.last_page}
                currentPage={paginator?.current_page || 1}
                onPageChange={handlePageChange}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Reports;
